import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { Minus, Plus } from "lucide-react";
import { API_URL } from "../../../utils/constant";
import axios from "axios";

const VendorPurchaseData = ({ show, onClose, heading, initialData = [], onSubmit, categories = [], suppliers = [] }) => {
    const [selectedCategory, setSelectedCategory] = useState(null);

    const [formData, setFormData] = useState({
        suppliers: [{ name: '', cost: ''}],
    });

    // Load initial data into form if editing an existing product
    useEffect(() => {
        if (initialData && initialData.name) {
            // console.log(initialData.RawProductVendors);
            setFormData({
                suppliers: initialData.RawProductVendors && initialData.RawProductVendors.length>0?initialData.RawProductVendors.map((vendor) => ({
                        name: vendor.vendor_id || '',
                        cost: vendor.purchase_cost || ''// Assuming 'quantity' exists in vendor data
                    }))
                    : [{ name: '', cost: '' }],
            });

            setSelectedCategory(initialData.RawCategory);
        } else {
            // If initialData is null or invalid, reset the form or clear it.
            setFormData({
                suppliers: [{ name: '', cost: '' }],
            });
            setSelectedCategory(null); // Reset selected category
        }
    }, [initialData, categories]); // Re-run when initialData or categories change


    // Handle input changes
    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData };

            if (type == 'checkbox') {
                updatedFormData[name] = checked ? 1 : 0;
            } else if (type == 'file') {
                updatedFormData[name] = files[0]; // Store the file in formData
            } else {
                updatedFormData[name] = value; // For other input types, just store the value
            }

            // Auto-generate the slug if the name field is being edited
            if (name === 'name') {
                const slug = value
                    .toLowerCase() // Convert to lowercase
                    .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric characters with hyphens
                    .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens

                updatedFormData.slug = slug; // Update the slug in the same formData object
            }

            return updatedFormData; // Return the updated state
        });
    };


    // Handle change for multiple fields (suppliers, purchase_costs)
    const handleDynamicChange = (e, index, field) => {
        const { value } = e.target;
        const updatedSuppliers = formData.suppliers.map((supplier, idx) =>
            idx === index ? { ...supplier, [field]: value } : supplier
        );
        setFormData({ ...formData, suppliers: updatedSuppliers });
    };

    // Handle adding a new supplier row
    const handleAddRow = () => {
        setFormData({
            ...formData,
            suppliers: [...formData.suppliers, { name: '', cost: '' }] // Add a new empty row
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formPayload = new FormData();

        const company = JSON.parse(localStorage.getItem('company'));
        // Loop through the formData and append the fields to formPayload
        for (let key in formData) {
            if (formData.hasOwnProperty(key)) {
                // If key is suppliers, handle it separately as it's an array
                if (key == 'suppliers' && Array.isArray(formData[key])) {
                    formData[key].forEach((supplier, index) => {
                        // Append each supplier's attributes separately, e.g. suppliers[name], suppliers[cost]
                        formPayload.append(`suppliers[${index}][name]`, supplier.name);
                        formPayload.append(`suppliers[${index}][cost]`, supplier.cost);
                    });
                } 
            }
        }
        if (company) {
            formPayload.append('company_id', company?.company?.id);
        }
        formPayload.append('product_id', initialData?.id);

        // setFormData({
        //     suppliers: [{ name: '', cost: '',}],
        // });
        // setSelectedCategory(null);
        await axios.post(`${API_URL}/raw-products/update-supplier-data/${company?.company?.id}`, formPayload)
        .then(response => {
            console.log('Success:', response.data);
            // Handle successful response here, like resetting form data
            setFormData({
                suppliers: [{ name: '', cost: '',}],
            });
            setSelectedCategory(null);
        })
        .catch((error) => {
            console.error('Error:', error);
            // Handle error here
        });
        onSubmit(formPayload);
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="row">
                    <div className="col-md-12">
                        <div className="row">
                            {/* Render all supplier-cost pairs */}
                            {formData.suppliers.map((supplier, index) => {
                            
                                const selectedSupplierIds = formData.suppliers.filter((_, idx) => idx !== index).map(sup => parseInt(sup.name)); // Collect selected supplier IDs
                            
                                return (
                                    <React.Fragment key={index}>
                                        {/* <div className="col-md-1">
                                            <img src={`${API_URL}/${supplier.barcode_image}`} />
                                        </div> */}
                                        <div className="col-md-10">
                                            <div className="form-group mb-4">
                                                <label>Supplier</label>
                                                <select
                                                    name="name"
                                                    className="form-control"
                                                    value={supplier.name}
                                                    onChange={(e) => handleDynamicChange(e, index, 'name')}
                                                
                                                >
                                                    <option value="">Select Supplier</option>
                                                    {suppliers && suppliers
                                                        .filter(sup => !selectedSupplierIds.includes(sup.id))
                                                        .map((sup) => (
                                                            <option key={sup.id} value={sup.id}>
                                                                {sup.name}
                                                            </option>
                                                        ))
                                                    }
                                                </select>

                                            </div>
                                        </div>

                                        {/* <div className="col-md-5">
                                            <div className="form-group mb-4">
                                                <label>Purchase Cost</label>
                                                <input
                                                    type="number"
                                                    name="cost"
                                                    className="form-control"
                                                    value={supplier.cost}
                                                    onChange={(e) => handleDynamicChange(e, index, 'cost')}
                                                    placeholder="Enter Purchase Cost"
                                                />
                                            </div>
                                        </div> */}


                                        {(
                                            index != 0 ? (
                                                <div className="col-md-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger mt-4"
                                                        onClick={() => {
                                                            const updatedSuppliers = formData.suppliers.filter(
                                                                (_, idx) => idx !== index
                                                            );
                                                            setFormData({ ...formData, suppliers: updatedSuppliers });
                                                        }}
                                                    >
                                                        <Minus />
                                                    </button>
                                                </div>
                                            ) : (<div className="col-md-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary mt-4"
                                                    onClick={handleAddRow}
                                                >
                                                    <Plus />
                                                </button>
                                            </div>)
                                        )}

                                    </React.Fragment>
                                );
                            })}

                        </div>
                    </div>

                </div>

                <div className="d-flex justify-content-end mt-4">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default VendorPurchaseData;
